<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (formLoading) {
  <div class="kbm-search-loading">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
@if (mailComposeLoading) {
  <div class="kbm-search-loading">
    <p-progressSpinner></p-progressSpinner>
    <div class="mt-2 mb-0 kbm-search-text">Preparing email...</div>
  </div>
}
<div class="topinfo d-flex align-items-center">
  <div class="col-lg-4 text-right toprighttext position-relative">
    <div class="d-flex justify-content-start gap-3 align-items-center topinfotr">
      <div class="d-flex gap-2">
        <span class="p-input-icon-right"><a href="/tapechart" target="_blank">
          <h1>T</h1>
        </a></span>
        <span class="p-input-icon-right"><a href="/reservations" target="_blank">
          <h1>R</h1>
        </a></span>
      </div>
      <span class="p-input-icon-right mr-5 mt-2">
        <i class="pi pi-search"></i>
        <input pInputText type="text" (change)="redirectToReservations()" [(ngModel)]="searchName"
          placeholder="Search" />
      </span>
    </div>
  </div>
  <div class="col-lg-8 text-right pr-5" style="display: flex; justify-content: end;gap:4px;">

    <div class="viewBtn">

      @if (ownerStmtId) {
        <button (click)="onOpenFormEdit()" class="btn btn-primary stmtBtn">View Owner Stmt</button>
      }

    </div>
    <div>
      <button type="button" class="btn btn-primary stmtBtn" (click)="regenerateStatement()">Regenerate
      Statement</button>
    </div>
    <div class="viewBtn">
      @if (ownerStmtId) {
        <button (click)="refreshStatement()" class="btn btn-primary stmtBtn">Refresh Stmt</button>
      }
    </div>
    <div class="viewBtn">
      @if (ownerStmtId) {
        <button (click)="sendStatementEmail($event,order)" class="btn btn-primary stmtBtn">Send
        Statement Email</button>
      }
    </div>
    <h2 class="m-0" style="font-size: 26px;"> {{formTitle}} #{{order?.shortTermRentalId}}</h2>
    <button mat-icon-button (click)="closePopUp()" class="close-btn" [mat-dialog-close]="true"
      style="float:right;background-color: transparent;">
      <i class="pi pi-times" aria-hidden="true"></i>
    </button>
  </div>

</div>
<mat-tab-group class="tabs-group edit-order-grp">
  <mat-tab label="Statement">
    <div>


      <!--<div class="mb-1 d-flex flex-wrap gap-2 align-items-center justify-content-between p-2 edit-order sticky-edit-order" style="background-color: #F0F2FF;">
      <div class="leftbtn">
        <div class="btn-groups mb-sm-0 mb-md-0 mb-lg-0">
          <button type="button" class="btn btn-primary" (click)="updateReservations()">Update</button>
          <button type="button" class="btn btn-light ml-2" [mat-dialog-close]="true" (click)="gotoReservation()">Cancel</button>
        </div>
      </div>
      <div class="rightselectbx d-flex gap-2 align-items-center flex-wrap">
        <button type="button" class="btn btn-primary ml-2" (click)="openCreateReservationPopUp()">Add
        Reservation</button>
        <span class="p-float-label">
          <select name="newurl2" (change)="onChangeSetEmailType($event.target.value)" class="form-select">
            <option value="">Select...</option>
            <option value="contract">Email Contract</option>
            <option value="invoice">Email Invoice</option>
            <option value="checkInDetails">Email Check-In Details</option>
            <option value="rentalCar">Email Rental Car Confirmation</option>
          </select>
        </span>
        <button type="button" class="btn btn-primary ml-2" (click)="sendReservationEmail()">Send Email
        </button>
        &lt;!&ndash; <span class="p-float-label">
        <p-dropdown [options]="lostFounds" formControlName="lostFoundId" optionLabel="itemName"
          optionValue="lostFoundId" [filter]="true" filterBy="itemName" [showClear]="false"
          placeholder="Select lost item name">
        </p-dropdown>
        <label for="Select lost item name">Select..</label>
      </span> &ndash;&gt;
    </div>
  </div>-->
  <div class="p-3">

    <div [formGroup]="form1">
      <!-- <div class="mb-1 d-flex align-items-center justify-content-between p-2" style="background-color: #F0F2FF;">
      <div class="leftbtn">
        <div class="btn-groups mtext-white m-0 py-1 fw-boldb-sm-0 mb-md-0 mb-lg-0">
          <button type="button" class="btn btn-primary">Update</button>
          <button type="button" class="btn btn-light ml-2" [mat-dialog-close]="true"
          (click)="gotoReservation()">Cancel</button>
        </div>
      </div>
      <div class="rightselectbx">
        <span class="p-float-label">
          <p-dropdown [options]="lostFounds" formControlName="lostFoundId" optionLabel="itemName"
            optionValue="lostFoundId" [filter]="true" filterBy="itemName" [showClear]="false"
            placeholder="Select lost item name">
          </p-dropdown>
          <label for="Select lost item name">Select lost item name</label>
        </span>
      </div>
    </div> -->

    <div class="row my-2">
      <div class="col-md-8">
        <div class="row">
          <div class="col-xl-3 col-lg-4 col-md-6 mt-3">
            <div class="d-flex gap-2">
              <div class="fw-bold text-black">
                Created :
              </div>
              <div>{{order?.createDate|date:'MM-dd-yyyy'}}</div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-4 col-md-6 mt-3">
            <div class="d-flex gap-2">
              <div class="fw-bold text-black">
                Start Date :
              </div>
              <div>{{order?.startDate|date:'MM-dd-yyyy'}}</div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-4 col-md-6 mt-3">
            <div class="d-flex gap-2">
              <div class="fw-bold text-black">
                End Date :
              </div>
              <div>{{order?.endDate |date:'MM-dd-yyyy'}}</div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-4 col-md-6 mt-3">
            <div class="d-flex gap-2">
              <div class="fw-bold text-black">
                Statement Id / Code :
              </div>
              <div>{{order?.ownerStmtId}} </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-4 col-md-6 mt-3">
            <div class="d-flex gap-2">
              <div class="fw-bold text-black">
                Property Code :
              </div>
              <div class="link-text" pTooltip="Open Property Profile" tooltipPosition="top"
                (click)="openPropertyProfile($event, order?.propertyProfileOwnerStmtSummary?.propertyProfileId)">
              {{order?.propertyCode}} </div>
            </div>
          </div>
          @if (order?.propertyManagementCommissionRate) {
            <div class="col-xl-3 col-lg-4 col-md-6 mt-3">
              <div class="d-flex gap-2">
                <div class="fw-bold text-black">
                  Mgmt Comm :
                </div>
                <div>{{order?.propertyManagementCommissionRate * 100 | number:'1.0-0'}} % </div>
              </div>
            </div>
          }
          @if (order?.propertyProfileOwnerStmtSummary?.trnsInEffectiveDate) {
            <div class="col-xl-3 col-lg-4 col-md-6 mt-3">
              <div class="d-flex gap-2">
                <div class="fw-bold text-black">
                  In Effective Date :
                </div>
                <div>{{order?.propertyProfileOwnerStmtSummary?.trnsInEffectiveDate | date:'MM-dd-yyyy'}} </div>
              </div>
            </div>
          }
          <div class="col-xl-3 col-lg-4 col-md-6 mt-3">
            <div class="d-flex gap-2">
              <div class="fw-bold text-black">
                Close :
              </div>
              <div>{{order?.endDate|date:'MM-dd-yyyy'}}</div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-4 col-md-6 mt-3">
            <div class="fw-bold text-black w-300px">

              <div [formGroup]="form">
                <span class="p-float-label w-100">
                  <p-dropdown dropdownIcon="fa fa-caret-down" class="w-100" [options]="stmtStatuses" formControlName="stmtStatus"
                    (onChange)="changeStatus($event.value)" optionLabel="label" optionValue="value"
                  [filter]="false"></p-dropdown>
                  <label for="Select Status">Select Status</label>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div>
            <div class="mt-3">
              <span class="p-float-label w-100 mb-1">
                <textarea [(ngModel)]="ownerNotes" [ngModelOptions]="{standalone: true}" class="w-100"
                id="ownerNotes" [rows]="2" pInputTextarea (input)="onOwnerNotesChange()"></textarea>
                <label for="ownerNotes">Owner Notes</label>
              </span>
              <!-- Action buttons - show when notes are changed -->
              @if (showOwnerNotesButtons) {
                <div class="d-flex gap-2 align-items-center">
                  <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
                    class="p-button-text cancel-btn p-button-sm" (click)="cancelOwnerNotesUpdate()"
                    [disabled]="updatingOwnerNotes">
                  </button>
                  <button pButton pRipple type="button" class="p-button-primary p-button-sm"
                    (click)="updateOwnerNotes()" [disabled]="updatingOwnerNotes">
                    @if (updatingOwnerNotes) {
                      <span>
                        <i class="pi pi-spin pi-spinner" style="margin-right: 0.5rem;"></i>
                        Updating...
                      </span>
                    }
                    @if (!updatingOwnerNotes) {
                      <span><i class="pi pi-check"></i> Update</span>
                    }
                  </button>
                </div>
              }
            </div>
            <div class="mt-3">
              <span class="p-float-label w-100 mb-3">
                <textarea formControlName="changeLog" class="w-100" id="changeLog" [rows]="2" readonly="true"
                pInputTextarea></textarea>
                <label for="changeLog">Change Log</label>
                @for (validation of validationMessages.changeLog; track validation) {
                  <span>
                    @if (form1.get('changeLog').hasError(validation.type) && (form1.get('changeLog').dirty || form1.get('changeLog').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
          </div>
        </div>

        <!-- Nights Summary Card -->


        <div class="row mt-3">
          <div class="col-md-7">
            <div class="px-3 mb-3 justify-content-between tabletile" style="background-color: maroon;">
              <div>
                <h2 class="text-white m-0 py-1 fw-bold">SUMMARY</h2>
              </div>
            </div>

            <div>
              <div>
                <div>
                  <div class="px-0 summary-table-container">
                    <!-- Loading Indicator -->
                    @if (summaryLoading) {
                      <div class="summary-loading-overlay">
                        <div class="summary-loading-content">
                          <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="4"></p-progressSpinner>
                          <p class="mt-2 mb-0">Loading summary...</p>
                        </div>
                      </div>
                    }
                    <div class="summary-table-scroll table-responsive-xl" [class.summary-content-loading]="summaryLoading">
                      <table class="table table-bordered mb-3 summary-table">
                        @if (ownerStmtPdfSplitByOwner) {
                          <thead>
                            <tr>
                              <th class="summary-label-col text-start"></th>
                              @for (split of ownerStmtPdfSplitByOwner; track split) {
                                <th class="text-center summary-split-th">
                                {{ getSplitOwnerHeading(split) }}</th>
                              }
                              <th class="text-center">Total</th>
                            </tr>
                          </thead>
                        }
                        <tbody>
                          @for (row of summaryRowsConfig; track row) {
                            <tr [ngClass]="row.rowClass">
                              <td class="summary-label-col" [class.cursor-pointer]="row.taxBreakdown"
                                (click)="row.taxBreakdown && openTaxBreakdownDialog(row.taxBreakdown)">
                                @if (row.taxBreakdown) {
                                  {{ row.label }} <i class="info-icon pi pi-info-circle ms-1"
                                [attr.title]="'View Tax ' + (row.taxBreakdown === 'revenue' ? 'Revenue' : 'Expense') + ' Breakdown'"></i>
                              }
                              @if (!row.taxBreakdown) {
                                @if (row.rowClass) {
                                  <b>{{ row.label
                                  }}</b>
                                  }@if (!row.rowClass) {
                                  {{ row.label
                                  }}
                                }
                              }
                            </td>
                            @for (split of ownerStmtPdfSplitByOwner; track split) {
                              <td>
                                @if (row.stmtSummeryField !== null && getSplitOwnerValue(split, row.stmtSummeryField) !== null) {
                                  @if (row.rowClass) {
                                    <b
                                      >{{ getSplitOwnerValue(split, row.stmtSummeryField) |
                                    statementAmount }}</b>
                                    }@if (!row.rowClass) {
                                    {{
                                    getSplitOwnerValue(split, row.stmtSummeryField) | statementAmount
                                    }}
                                  }
                                }
                                @if (row.stmtSummeryField === null || getSplitOwnerValue(split, row.stmtSummeryField) === null) {
                                  —
                                }
                              </td>
                            }
                            <td>@if (row.rowClass) {
                              <b>{{ getSummaryTotal(row) | statementAmount
                              }}</b>
                              }@if (!row.rowClass) {
                              {{ getSummaryTotal(row) | statementAmount
                              }}
                            }</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-5">
          @if (!summaryLoading) {
            <div>
              <div class="summary-card p-3">
                <div class="main-heading">
                  <strong>NIGHTLY SUMMARY</strong>
                </div>
                <div class="d-flex gap-5 mt-4 flex-wrap">
                  <div>
                    <div>Total Paid Nights</div>
                    <div class="fw-bold">{{summaryPaidNights || 0}} Nights · {{summaryOccupancyRate || 0}}% Occupied
                    </div>
                  </div>
                  <div>
                    <div>Guest Nights</div>
                    <div class="fw-bold">{{summaryGuestNights || 0}} Nights · {{summaryGuestNightsOccupancyRate ||
                    0}}% Occupied</div>
                  </div>
                  <div>
                    <div>Owner Nights</div>
                    <div class="fw-bold">{{summaryOwnerNights || 0}} Nights · {{summaryOwnerNightsOccupancyRate ||
                    0}}% Occupied</div>
                  </div>
                  <div>
                    <div>Owner Guest Nights</div>
                    <div class="fw-bold">{{summaryOwnerGuestNights || 0}} Nights ·
                    {{summaryOwnerGuestNightsOccupancyRate || 0}}% Occupied</div>
                  </div>
                  <div>
                    <div>Maintenance Nights</div>
                    <div class="fw-bold">{{summaryMaintenanceNights || 0}} Nights ·
                    {{summaryMaintenanceNightsOccupancyRate || 0}}% Occupied</div>
                  </div>
                </div>
              </div>
            </div>
          }


          <div>
            <div class="summary-card mt-2 p-3">
              <div class="main-heading">
                <strong>HOMEOWNER BENEFITS - {{ownerStmtOjb?.stmtYear}} ( Complimentary )</strong>
              </div>
              <div class="d-flex gap-4 flex-wrap justify-content-between mt-4">
                @if (ownerStmtOjb?.freeDepartureCleanNUM > 0) {
                  <div>
                    <div>Housekeepings</div>
                    <div class="fw-bold">{{ownerStmtOjb?.usedFreeDepartureCleanNUM || 0}} used ·
                    {{ownerStmtOjb?.freeDepartureCleanNUM || 0}} allotted</div>
                  </div>
                }
                @if (ownerStmtOjb?.freeCarDaysNUM > 0) {
                  <div>
                    <div>Rental Car Days</div>
                    <div class="fw-bold">{{ownerStmtOjb?.usedFreeCarDaysNUM || 0}} used ·
                      {{ownerStmtOjb?.freeCarDaysNUM ||
                    0}} allotted</div>
                  </div>
                }
                <div>
                  <div>Maintenance</div>
                  <div class="fw-bold">{{getValueByMonth('YTD', 'maintenanceCreditTotal') |
                    statementAmount}}
                  </div>
                </div>
                @if (!(ownerStmtOjb?.freeCarDaysNUM > 0)) {
                  <div></div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Reservations  -->

      <div class="mt-3">
        @for (reservation of order?.ownerStmtRezs; track reservation; let i = $index) {
          <div [id]="'stmt-'+i">
            <div>
              <app-statement-detail [paymentSources]="null" (refreshOrder)="doRefreshOrder()"
                [reservation]="reservation" [type]="'Reservation'" [shortTermRentalId]="order.shortTermRentalId"
                (getReservations)="getReservationlist($event)" [reservationCount]="order?.ownerStmtRezs.length"
              [reservationIndex]="i + 1"></app-statement-detail>
            </div>
          </div>
        }
      </div>

      <!-- Maintenance and Housekeeping  -->

      @if (expenseLoading) {
        <div class="kbm-search-loading">
          <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="4"></p-progressSpinner>
          <div class="mt-2 mb-0 text-white">Opening Expense...</div>
        </div>
      }

      @if (order?.ownerStmtExps && order?.ownerStmtExps.length > 0) {
        <div>
          <div class="px-3 mb-3 justify-content-between tabletile" style="background-color: maroon;">
            <div>
              <h2 class="text-white m-0 py-1 fw-bold">MAINTENANCE & HOUSEKEEPING</h2>
            </div>
          </div>
          <div>
            <div class="p-0">
              <div class="table-responsive-xl mb-3">
                <p-table [value]="order?.ownerStmtExps" styleClass="p-datatable-striped"
                  [tableStyle]="{'min-width':'50rem'}" dataKey="ownerStmtExpId">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 3rem;"></th>
                      <th>#</th>
                      <th class="text-nowrap">Expense Date</th>
                      <th class="text-nowrap">KBM Paid</th>
                      <th class="text-nowrap">Owner Paid</th>
                      <!-- <th [pSortableColumn]="'expenseCategory'" class="text-nowrap">Category
                      <p-sortIcon [field]="'expenseCategory'"></p-sortIcon>
                    </th> -->
                    <th>Category</th>
                    <th>Name & Description</th>
                    <th style="width: 60px;"></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-expense let-expanded="expanded">
                  <tr class="cursor-pointer">
                    @if (expense?.ownerStmtDetails && expense.ownerStmtDetails.length > 0) {
                      <td>
                        <i [class]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                        [pRowToggler]="expense"></i>
                      </td>
                    }
                    @if (!expense?.ownerStmtDetails || expense.ownerStmtDetails.length === 0) {
                      <td></td>
                    }
                    <td (click)="openExpenseEdit(expense)">{{expense.ownerStmtExpId}}</td>
                    <td class="text-nowrap" (click)="openExpenseEdit(expense)">{{expense.expenseDate | date:
                    'MM-dd-yyyy'}}</td>
                    <td (click)="openExpenseEdit(expense)">{{expense.amountPaidByKBM | statementAmount }}</td>
                    <td (click)="openExpenseEdit(expense)">{{expense.amountPaidByOwner | statementAmount}}</td>
                    <td (click)="openExpenseEdit(expense)">{{getExpenseCategoryName(expense?.expenseCategory)}}
                    </td>
                    <td (click)="openExpenseEdit(expense)">
                      <div class="fw-bold">
                        {{expense.name}}
                      </div>
                      <div>
                        <small class="text-muted">{{expense.description}}</small>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="d-flex justify-content-center align-items-center">
                        <a (click)="openExpenseEdit(expense); $event.stopPropagation()"
                          style="cursor: pointer;">
                          <i style="color: blue;" class="pi pi-pencil"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="rowexpansion" let-expense>
                  <tr>
                    <td></td>
                    <td colspan="6" class="p-0 thick-border">
                      <div>
                        <app-statement-detail-list [tableBackground]="'#f0f0f0'"
                          [styleClass]="'p-datatable p-datatable-grey'" [fontStyle]="'italic !important'"
                          [compactHeader]="true" [hideServiceDate]="true" [hideName]="false"
                          [showHeaders]="true" [ownerStmtExp]="expense" [reservation]="expense"
                          [showPagination]="false" [type]="'Expense'" [orderDetails]="expense.ownerStmtDetails"
                          [shortTermRentalId]="order.shortTermRentalId" (refreshOrder)="doRefreshOrder()"
                        [orderId]="expense?.order?.orderId"></app-statement-detail-list>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="footer">
                  <tr style="background-color: #f8f9fa; font-weight: bold;">
                    <td></td>
                    <td></td>
                    <td class="fw-bold text-end">Total</td>
                    <td>{{getTotalKbmPaid() | statementAmount}}</td>
                    <td>{{getTotalOwnerPaid() | statementAmount}}</td>
                    <td colspan="3"></td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div>
    }


  </div>
  <div class="col-md-4 sticky-summary-column">
    <app-notes-chat [config]="notesChatConfig" [noteSourceId]="ownerStmtId" [noteSource]="100">
    </app-notes-chat>
  </div>
</div>

<!-- YEAR TO DATE: per-owner sections when split exists -->
@if (ownerStmtPdfSplitByOwner) {
  @for (split of ownerStmtPdfSplitByOwner; track split) {
    <div class="mt-5">
      <div class="px-3 my-3 justify-content-between tabletile" style="background-color: maroon;">
        <div>
          <h2 class="text-white m-0 py-1 fw-bold">YEAR TO DATE ( {{ getSplitOwnerHeadingForYtd(split) }} )</h2>
        </div>
      </div>
      <div class="mx-0y-5 gy-lg-0 m-3">
        <div class="p-0">
          <div class="row m-0">
            <div class="col-md-12 px-0">
              <div class="table-responsive-xl">
                @if (split?.yearlySummary?.stmtSummeryAPIs) {
                  <table class="table table-bordered mb-3"
                    style="text-align: right !important;">
                    <thead>
                      <tr>
                        <th [ngStyle]="{ width: 'fit-content' }"></th>
                        @for (month of months; track month) {
                          <th class="text-center">{{ month | slice : 0 : 3 }}</th>
                        }
                      </tr>
                    </thead>
                    <tbody align="right">
                      @for (row of tableRows; track row) {
<tr [ngClass]="{
                              'total-net-proceeds-row': row.field === 'totalNetProceed',
                              'payment-to-owner-row': row.field === 'paymentToOwner',
                              'total-revenue-row': row.field === 'totalRevenueWithExpenseCredit',
                              'total-expense-row': row.field === 'totalExpenseWithExpenseCredit'
                            }">
                          <td>{{ row.label }}</td>
                          @for (month of months; track month) {
                            <td>
                              {{ ['paidNights', 'occupancyRate', 'guestNight', 'ownerNights',
                              'maintenanceNights','ownerGuestNights'].includes(row.field) ?
                              getValueByMonthForSplit(split, month, row.field) : (getValueByMonthForSplit(split,
                              month, row.field) | statementAmount) }}
                              {{ row.field === 'occupancyRate' ? "%" : "" }}
                            </td>
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

<div class="mt-5">
  <div class="px-3 my-3 justify-content-between tabletile" style="background-color: maroon;">
    <div>
      <h2 class="text-white m-0 py-1 fw-bold">YEAR TO DATE{{ ownerStmtPdfSplitByOwner ? ' ( Total )' : '' }}
      </h2>
    </div>
  </div>
  <div class="mx-0y-5 gy-lg-0 m-3">
    <div class=" p-0">
      <div class="row m-0">
        <div class="col-md-12 px-0">
          <div class="table-responsive-xl">
            @if (ownerStmtOjb) {
              <table class="table table-bordered mb-3"
                style="text-align: right !important;">
                <thead>
                  <tr>
                    <th [ngStyle]="{ width: 'fit-content' }"></th>
                    @for (month of months; track month) {
                      <th class="text-center">{{ month | slice : 0 : 3 }}</th>
                    }
                  </tr>
                </thead>
                <tbody align="right">
                  @for (row of tableRows; track row) {
<tr [ngClass]="{ 
                                                            'total-net-proceeds-row': row.field === 'totalNetProceed',
                                                            'payment-to-owner-row': row.field === 'paymentToOwner',
                                                            'total-revenue-row': row.field === 'totalRevenueWithExpenseCredit',
                                                            'total-expense-row': row.field === 'totalExpenseWithExpenseCredit'
                                                          }">
                      <td>{{ row.label }}</td>
                      @for (month of months; track month) {
                        <td>
                          {{ ['paidNights', 'occupancyRate', 'guestNight', 'ownerNights',
                          'maintenanceNights','ownerGuestNights'].includes(row.field) ? getValueByMonth(month,
                          row.field) : (getValueByMonth(month, row.field) | statementAmount) }}
                          {{ row.field === 'occupancyRate' ? "%" : "" }}
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</div>











<!--<div class="row mx-0y-5 gy-lg-0 m-3">
<div class="col-lg-12 invoicetable p-0">
  <div class="row m-0">
    <div class="col-lg-11 pr-5 pl-0">
      <div class="table-responsive-xl">
        <table class="table table-bordered mb-3">
          <thead align="center">
            <tr>
              <th style="width: 120px">
                Date
              </th>
              <th style="width: 130px">
                Type
              </th>
              <th style="width: 500px">
                Description
              </th>
              <th>
                Paid By
                KBM Hawaii
              </th>
              <th class="text-right">
                Paid By
                Owner
              </th>

            </tr>
          </thead>
          <tbody align="right">
            <tr *ngFor="let orderDetail of order?.orderInvoice?.orderDetails">
              <td>{{getPropertyCode(orderDetail)}}</td>
              <td>{{order?.createDate | date:'MM-dd-yyyy'}}</td>
              <td>{{orderDetail?.name}}</td>
              <td>{{orderDetail?.quantity}}</td>
              <td style="text-align: right;">{{orderDetail?.listPrice | statementAmount}}
              </td>
              <td style="text-align: right;">{{orderDetail.listPriceAdjustmentAmount | statementAmount}}
              </td>

            </tr>
            <tr>

              <td></td>
              <td></td>
              <td></td>
              <td class="text-right">
                <b>
                  Sub Total :
                </b>
              </td>
              <td class="text-right">
                <b>{{order?.orderInvoice?.ttlExpense | statementAmount}}</b>
              </td>
              &lt;!&ndash; <td class="text-right">
              <b>{{order?.orderInvoice?.ttlTax | currency : 'USD'}}</b>
            </td>
            <td class="text-right">
              <b>{{order?.orderInvoice?.ttlExpenseWithTax | currency : 'USD'}}</b>
            </td>&ndash;&gt;
          </tr>
          <tr></tr>


          &lt;!&ndash;<tr>
          <td colspan="8" class="text-right">
            <b>
              Outstanding Balance :
            </b>
          </td>
          <td class="text-right">
            <b>
              {{(order?.orderInvoice?.ttlDue) | currency : 'USD'}}
            </b>
          </td>
        </tr>

        <tr></tr>&ndash;&gt;

        &lt;!&ndash; <tr *ngIf="order?.orderInvoice?.orderInvoiceDetails.length > 0">
        <td colspan="5">
          {{order?.orderInvoice?.orderInvoiceDetails[0]?.description}} {{reservation?.order?.orderInvoice?.orderInvoiceDetails[0]?.createDate | date:'MM-dd-yyyy'}} :
        </td>
        <td>
          (${{order?.orderInvoice?.orderInvoiceDetails[0]?.amount}})
        </td>
      </tr>
      <tr *ngIf="order?.orderInvoice?.orderInvoiceDetails[0]?.amount == undefined">
        <td colspan="5">
          Payments received as of {{order?.createDate | date:'MM-dd-yyyy'}}
        </td>
        <td>
          ($0.00)
        </td>
      </tr> &ndash;&gt;
      &lt;!&ndash; Payments received as of  &ndash;&gt;
      &lt;!&ndash; <tr></tr>

      <tr>
        <td colspan="5">
          <b>
            Outstanding balance :
          </b>
        </td>
        <td>
          <b>
            {{grandTotals + reservation?.order?.orderInvoice?.orderInvoiceDetails[0]?.amount | currency : 'USD'}}
          </b>
        </td>
      </tr> &ndash;&gt;
      &lt;!&ndash;<tr>
      <td colspan="9" class="text-start">
        <b style="font-size: 16px; color:#505050">
          Payment due dates
        </b>
      </td>
    </tr>
    <tr *ngFor="let orderInvoiceDetail of order?.orderInvoice?.orderInvoiceDetails; let i = index">
      <td colspan="8" *ngIf="orderInvoiceDetail?.type == 1">
        {{orderInvoiceDetail?.description}}
      </td>
      <td *ngIf="orderInvoiceDetail?.type == 1">
        {{orderInvoiceDetail?.amount | currency : 'USD'}}
      </td>
    </tr>&ndash;&gt;

  </tbody>
</table>
</div>
</div>
<div class="col-lg-6">
  &lt;!&ndash; <ul class="list-group list-group-horizontal mb-3 lightbluebtn">
  <li class="list-group-item border-radius w-100">
    <ul class="d-flex flex-column w-100 m-0 list-unstyled gap-2">
      <li class="mr-2"><a href="#">View Contract</a></li>
      <li _ngcontent-niq-c450=""><a href="#">View Invoice</a></li>
    </ul>
  </li>
</ul> &ndash;&gt;
</div>
</div>
</div>

</div>-->




<!-- <div class="mb-3 row mx-0 align-items-center justify-content-between" style="background-color: #F0F2FF;">
<div class="col-sm-12 p-0 leftbtn">
  <div class="btn-groups mb-sm-0 mb-md-0 mb-lg-0 p-2">
    <button type="button" class="btn btn-primary" (click)="updateReservations()">Update</button>
    <button type="button" class="btn btn-light ml-2" [mat-dialog-close]="true"
    (click)="gotoReservation()">Cancel</button>
    <button type="button" class="btn btn-primary ml-2" (click)="openCreateReservationPopUp()">Add Reservation</button>
  </div>
</div>
</div> -->

</div>


</mat-tab>
<!--<mat-tab label="Guest Communication">
&lt;!&ndash;
parameter passed and stage based on that SMS or mail template is sent
now that we have live merge of template we dont need custom message sending from custom buttons
&ndash;&gt;
&lt;!&ndash; <button pButton class="btn-addt p-button" (click)="sendGuestComm( 100)">Send welCome Checkin</button>
<button pButton class="btn-addt p-button" (click)="sendGuestComm(200)">Send Day After Checkin</button>
<button pButton class="btn-addt p-button" (click)="sendGuestComm(300)">Send Day Before Checkout</button>
<button pButton class="btn-addt p-button" (click)="sendGuestComm(400)">Send Day After Checkout</button>
<button pButton class="btn-addt p-button" (click)="sendGuestComm(500)">Send Week After Checkout</button>&ndash;&gt;



<app-inbox-list-guest *ngIf="isReservationLoaded" [msgTopic]="100" [msgTemplateData]="msgTemplateData" [msgTopicId]="reservations[0]?.reservationId" [orderId]="orderId"></app-inbox-list-guest>
</mat-tab>
<mat-tab label="History">
  <app-audit-list *ngIf="order?.reservations.length > 0" [auditUrl]="'reservation/' + order?.reservations[0]?.reservationId + '/audit'"></app-audit-list>
</mat-tab>-->
</mat-tab-group>

<p-dialog class="payment-popup" header="PAYMENT SRC & CONF EDIT" [(visible)]="visible" [modal]="true"
  [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false"
  [ngClass]="{'has-error': form4.invalid && (form4.dirty || form4.touched)}">
  <div [formGroup]="form4" class="">
    <div class="common-popup mt-1">
      <h3>Invoice Order Details</h3>
      <div class="d-flex flex-wrap">
        <div class="col-6">
          <div class="p-float-label">
            <p-dropdown class="w-100" [options]="applyToList" formControlName="reservationId" optionLabel="name"
            optionValue="value" placeholder="" appendTo="body"></p-dropdown>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <p-calendar formControlName="effectiveDate" id="effectiveDate">
            </p-calendar>
            <label for="Date">Initiated</label>
          </div>
        </div>

        <div class="col-6">
          <div class="p-float-label">
            <p-dropdown class="w-100" [options]="invoiceDetailTypes" formControlName="type" optionLabel="name"
            optionValue="value" placeholder=""></p-dropdown>
            <label for="Date">Trx</label>
          </div>
        </div>

        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="description" id="description" type="text" pInputText>
            <label for="Date">Guest Notes</label>
          </div>
        </div>

        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="privateNotes" id="privateNotes" type="text" pInputText>
            <label for="Date">Private Notes </label>
          </div>
        </div>
      </div>
    </div>
    <div formGroupName="paymentConfirm" class="common-popup mt-1">
      <h3>PaymentConfirm</h3>
      <div class="d-flex flex-wrap">
        <div class="col-6">
          <div class="p-float-label">
            <p-calendar formControlName="paymentProcessDate" inputId="pageStartDate">
            </p-calendar>
            <label for="Date">Received</label>
            @for (validation of validationMessages3.paymentProcessDate; track validation) {
              <span>
                @if (form4.get('paymentConfirm.paymentProcessDate').hasError(validation.type) && (form4.get('paymentConfirm.paymentProcessDate').dirty || form4.get('paymentConfirm.paymentProcessDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <p-inputNumber formControlName="paymentProcessAmount" [minFractionDigits]="2" inputId="currency-us"
              mode="currency" currency="USD" locale="en-US">
            </p-inputNumber>
            <label for="paymentProcessAmount">Amount</label>
            @for (validation of validationMessages3.paymentProcessAmount; track validation) {
              <span>
                @if (form4.get('paymentConfirm.paymentProcessAmount').hasError(validation.type) && (form4.get('paymentConfirm.paymentProcessAmount').dirty || form4.get('paymentConfirm.paymentProcessAmount').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <p-dropdown [options]="paymentTypes" formControlName="paymentType" optionLabel="name" optionValue="value"
              [filter]="false" filterBy="name" [showClear]="false" placeholder="Payment Type">
            </p-dropdown>
            <label for="paymentType">Type</label>
            @for (validation of validationMessages3.paymentType; track validation) {
              <span>
                @if (form4.get('paymentConfirm.paymentType').hasError(validation.type) && (form4.get('paymentConfirm.paymentType').dirty || form4.get('paymentConfirm.paymentType').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="paymentGatewayProvider" id="paymentGatewayProvider" type="text" pInputText>
            <label for="paymentGatewayProvider">Payment Gateway Provider</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="paymentTransactionConfirmNumber" id="paymentTransactionConfirmNumber" type="text"
              pInputText>
            <label for="paymentTransactionConfirmNumber">Conf#</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="paymentSourceAccountIdentifier" id="paymentSourceAccountIdentifier" type="text"
              pInputText>
            <label for="paymentSourceAccountIdentifier">Chk#</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <p-dropdown class="w-100" formControlName="paymentProceedsDepositedToAccountIdentifier"
            [options]="paymentDepositTypes" optionLabel="name" optionValue="value" placeholder=""></p-dropdown>
            <label for="paymentProceedsDepositedToAccountIdentifier">Deposit A/C#</label>
          </div>
        </div>

        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="billingName" id="billingName" type="text" pInputText>
            <label for="billingName">Billing Name</label>
            @for (validation of validationMessages3.billingName; track validation) {
              <span>
                @if (form4.get('paymentConfirm.billingName').hasError(validation.type) && (form4.get('paymentConfirm.billingName').dirty || form4.get('paymentConfirm.billingName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="billingStreetAddress" id="billingStreetAddress" type="text" pInputText>
            <label for="billingStreetAddress">Billing Street Address</label>
            @for (validation of validationMessages3.billingStreetAddress; track validation) {
              <span>
                @if (form4.get('paymentConfirm.billingStreetAddress').hasError(validation.type) && (form4.get('paymentConfirm.billingStreetAddress').dirty || form4.get('paymentConfirm.billingStreetAddress').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="billingCity" id="billingCity" type="text" pInputText>
            <label for="billingCity">Billing City</label>
            @for (validation of validationMessages3.billingCity; track validation) {
              <span>
                @if (form4.get('paymentConfirm.billingCity').hasError(validation.type) && (form4.get('paymentConfirm.billingCity').dirty || form4.get('paymentConfirm.billingCity').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="billingState" id="billingState" type="text" pInputText>
            <label for="billingState">Billing State</label>
            @for (validation of validationMessages3.billingState; track validation) {
              <span>
                @if (form4.get('paymentConfirm.billingState').hasError(validation.type) && (form4.get('paymentConfirm.billingState').dirty || form4.get('paymentConfirm.billingState').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="billingPostalCode" id="billingPostalCode" type="text" pInputText>
            <label for="billingPostalCode">Billing Postal Code</label>
            @for (validation of validationMessages3.billingPostalCode; track validation) {
              <span>
                @if (form4.get('paymentConfirm.billingPostalCode').hasError(validation.type) && (form4.get('paymentConfirm.billingPostalCode').dirty || form4.get('paymentConfirm.billingPostalCode').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <p-dropdown [options]="countries" formControlName="billingCountry" optionLabel="name" optionValue="abbr"
            [filter]="true" filterBy="name" [showClear]="false" placeholder="Billing Country"></p-dropdown>
            <label for="billingCountry">Billing Country</label>
            @for (validation of validationMessages3.billingCountry; track validation) {
              <span>
                @if (form4.get('paymentConfirm.billingCountry').hasError(validation.type) && (form4.get('paymentConfirm.billingCountry').dirty || form4.get('paymentConfirm.billingCountry').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </div>
        </div>

      </div>
    </div>


    <div formGroupName="paymentConfirm" class="common-popup mt-1">
      <h3>PaymentSource</h3>
      <div formGroupName="paymentSource" class="d-flex flex-wrap">
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="achBankName" id="achBankName" type="text" pInputText>
            <label for="achBankName">Ach Bank Name</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="achRoutingNumber" id="achRoutingNumber" type="text" pInputText>
            <label for="achRoutingNumber">Ach Routing Number</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="achBankAccountNumber" id="achBankAccountNumber" type="text" pInputText>
            <label for="achBankAccountNumber">Ach Bank Account Number</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="achBranchSortCode" id="achBranchSortCode" type="text" pInputText>
            <label for="achBranchSortCode">Ach Branch Sort Code</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="achAccountType" id="achAccountType" type="text" pInputText>
            <label for="achAccountType">Ach Account Type</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="achCheckNumber" id="achCheckNumber" type="text" pInputText>
            <label for="achCheckNumber">Ach Check Number</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input formControlName="achMicrData" id="achMicrData" type="text" pInputText>
            <label for="achMicrData">Ach Micr Data</label>
          </div>
        </div>
        <br>
          <!-- <div class="col-6">
          <div class="p-float-label">
            <p-dropdown [options]="paymentTypes" formControlName="paymentType" optionLabel="name"
              optionValue="value" [filter]="false" filterBy="name" [showClear]="false"
              placeholder="Payment type">
            </p-dropdown>
            <label for="cn">Credit Card Type</label>
          </div>
        </div> -->
        <div class="col-6">
          <div class="p-float-label">
            <input name="creditCardNumber" formControlName="creditCardNumber" name="creditCardNumber" minlength="15"
              maxlength="19" type="text" autocomplete="cc-number" pInputText>
            <label for="creditCardNumber">Credit Card Number</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <p-dropdown [options]="cardExpiryMonths" formControlName="creditCardExpirationMonth" optionLabel="name"
              optionValue="value" [filter]="false" filterBy="name" [showClear]="false"
            placeholder="Credit Card Expiration Month"> </p-dropdown>
            <label for="creditCardExpirationMonth">Credit Card Expiration Month</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <p-dropdown [options]="cardExpiryYears" formControlName="creditCardExpirationYear" optionLabel="name"
              optionValue="value" [filter]="false" filterBy="name" [showClear]="false"
              placeholder="Credit Card Expiration Year">
            </p-dropdown>
            <label for="creditCardExpirationYear">Credit Card Expiration Year</label>
          </div>
        </div>
        <div class="col-6">
          <div class="p-float-label">
            <input name="creditCardSecurityCode" formControlName="creditCardSecurityCode" type="number" pInputText>
            <label for="creditCardSecurityCode">Credit Card Security Code</label>
          </div>
        </div>
        <!-- <div class="col-12">
        <div class="p-float-label">
          <textarea name="" id=""></textarea>
          <label for="cs">Log</label>
        </div>
      </div> -->

    </div>
  </div>

  <div class="col-sm-12 p-0 leftbtn">
    <div class="d-flex align-items-center justify-content-between">
      <div class="btn-groups mb-sm-0 mb-md-0 mb-lg-0 py-2">
        <button type="button" class="btn-delete btn btn-light p-button-outlined p-button-danger"
        (click)="deleteOrderInvoiceDetailConfirmation()">Delete</button>
      </div>
      <div class="text-center">
        <a style="font-size: 14px; color: #3F51B5;" (click)="sendEmailPaymentRecieveToGuest()">Email Payment
        Received</a>
      </div>
      <div class="btn-groups mb-sm-0 mb-md-0 mb-lg-0 py-2">
        <button type="button" class="btn-cancel btn btn-light p-button-text mr-2"
        (click)="closeDialog()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="updateInvoiceOrder()">Update</button>
      </div>
    </div>
  </div>
</div>


</p-dialog>

<!-- Tax Breakdown Dialog -->
<p-dialog [header]="taxBreakdownTitle" [(visible)]="showTaxBreakdownDialog" [modal]="true" [style]="{ width: '600px' }"
  [breakpoints]="{ '960px': '80vw', '640px': '90vw' }" [draggable]="false" [resizable]="false">
  <div class="tax-breakdown-content">
    <p-table [value]="taxBreakdownData" styleClass="p-datatable-sm">
      <ng-template pTemplate="header">
        <tr>
          <th style="text-align: left; padding: 8px;">Tax Name</th>
          <th style="text-align: right; padding: 8px;">Tax Amount</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-tax>
        <tr>
          <td style="padding: 8px;">{{tax.name || '-'}}</td>
          <td style="padding: 8px; text-align: right;">
            {{tax.amount | statementAmount}}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer">
        <tr style="background-color: #f8f9fa; font-weight: 600;">
          <td style="padding: 8px; text-align: right;">Total:</td>
          <td style="padding: 8px; text-align: right;">
            {{getTotalTaxAmount() | statementAmount}}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-dialog>

<!-- <p-dialog *ngIf="errorList.length > 0 && showValidationErrors" header="Reservation Update Info"
[(visible)]="showValidationErrors" [style]="{width: 'auto', height: 'auto'}">
<div class="error-mess" [innerHTML]="errorMessages"></div>
</p-dialog> -->